import axios from 'axios';

const rawBaseUrl = process.env.REACT_APP_API_URL || `${window.location.origin}/api`;
const baseUrl = rawBaseUrl.endsWith("/api") ? rawBaseUrl : `${rawBaseUrl.replace(/\/$/, "")}/api`;

const handleResponse = (response) => {
  if (response?.data) {
    return response.data;
  }

  return {
    isSuccess: false,
    resultMessage: 'Beklenmeyen cevap alındı.',
  };
};

export async function getSportsRegionsWithFacilities() {
  try {
    const res = await axios.get(`${baseUrl}/sports/regions-with-facilities`);
    return handleResponse(res);
  } catch (error) {
    console.error('[SportsAppointment] regions error', error);
    return {
      isSuccess: false,
      resultMessage: error?.message || 'Bölgeler alınamadı.',
    };
  }
}

export async function getSportsAvailableSlots(facilityId, date, sportTypeId) {
  try {
    const res = await axios.get(`${baseUrl}/sports/available-slots/${facilityId}`, {
      params: {
        date,
        sportTypeId,
        _t: Date.now()
      },

    });
    return handleResponse(res);
  } catch (error) {
    console.error('[SportsAppointment] available slots error', error);
    return {
      isSuccess: false,
      resultMessage: error?.message || 'Saat dilimleri alınamadı.',
    };
  }
}

export async function createSportsAppointment(payload) {
  try {
    const res = await axios.post(`${baseUrl}/sports/appointments`, payload);
    return handleResponse(res);
  } catch (error) {
    console.error('[SportsAppointment] create error', error);
    const message =
      error?.response?.data?.resultMessage ||
      error?.message ||
      'Randevu oluşturulamadı.';
    return {
      isSuccess: false,
      resultMessage: message,
      errors: error?.response?.data?.errors,
    };
  }
}

export async function verifySportsAppointment(appointmentId, verificationCode) {
  try {
    const res = await axios.post(`${baseUrl}/sports/verify`, {
      appointmentId,
      verificationCode,
    });
    return handleResponse(res);
  } catch (error) {
    console.error('[SportsAppointment] verify error', error);
    const message =
      error?.response?.data?.resultMessage ||
      error?.message ||
      'Doğrulama başarısız.';
    return {
      isSuccess: false,
      resultMessage: message,
    };
  }
}

export async function getSportsAppointmentById(appointmentId) {
  try {
    const res = await axios.get(`${baseUrl}/sports/appointments/${appointmentId}`);
    return handleResponse(res);
  } catch (error) {
    console.error('[SportsAppointment] get by id error', error);
    const message =
      error?.response?.data?.resultMessage ||
      error?.message ||
      'Randevu detayları alınamadı.';
    return {
      isSuccess: false,
      resultMessage: message,
    };
  }
}

// SELF-SERVICE CANCELLATION
export async function getSportsAppointmentsByIdentity(identityNumber) {
  try {
    const res = await axios.get(`${baseUrl}/sports/appointments/by-identity/${identityNumber}`);
    return handleResponse(res);
  } catch (error) {
    console.error('[SportsAppointment] get by identity error', error);
    const message =
      error?.response?.data?.resultMessage ||
      error?.message ||
      'Randevular alınamadı.';
    return {
      isSuccess: false,
      resultMessage: message,
    };
  }
}

export async function requestSportsCancellation(payload) {
  try {
    const res = await axios.post(`${baseUrl}/sports/appointments/request-cancellation`, payload);
    return handleResponse(res);
  } catch (error) {
    console.error('[SportsAppointment] request cancellation error', error);
    const message =
      error?.response?.data?.resultMessage ||
      error?.message ||
      'İptal talebi gönderilemedi.';
    return {
      isSuccess: false,
      resultMessage: message,
    };
  }
}

export async function confirmSportsCancellation(payload) {
  try {
    const res = await axios.post(`${baseUrl}/sports/appointments/confirm-cancellation`, payload);
    return handleResponse(res);
  } catch (error) {
    console.error('[SportsAppointment] confirm cancellation error', error);
    const message =
      error?.response?.data?.resultMessage ||
      error?.message ||
      'İptal işlemi gerçekleştirilemedi.';
    return {
      isSuccess: false,
      resultMessage: message,
    };
  }
}

export async function getGenderRestrictions(facilityId) {
  try {
    const res = await axios.get(`${baseUrl}/sports-management/gender-restrictions`, {
      params: { facilityId }
    });
    return handleResponse(res);
  } catch (error) {
    console.error('[SportsAppointment] gender restrictions error', error);
    return {
      isSuccess: false,
      resultMessage: error?.message || 'Kısıtlamalar alınamadı.',
    };
  }
}

// PUBLIC EDUCATION
export async function getPublicEducationFacilities(onlyActive = true) {
  try {
    const res = await axios.get(`${baseUrl}/public-education/facilities`, {
      params: { onlyActive }
    });
    return handleResponse(res);
  } catch (error) {
    console.error('[PublicEducation] facilities error', error);
    return {
      isSuccess: false,
      resultMessage: error?.response?.data?.resultMessage || error?.message || 'Tesisler alınamadı.',
    };
  }
}

export async function getPublicEducationCourseSchedules(facilityId, sportTypeId) {
  try {
    const res = await axios.get(`${baseUrl}/public-education/course-schedules`, {
      params: {
        facilityId,
        sportTypeId
      }
    });
    return handleResponse(res);
  } catch (error) {
    console.error('[PublicEducation] course schedules error', error);
    return {
      isSuccess: false,
      resultMessage: error?.response?.data?.resultMessage || error?.message || 'Ders programı alınamadı.',
    };
  }
}

export async function createPublicEducationRegistration(payload) {
  try {
    const res = await axios.post(`${baseUrl}/public-education/registrations`, payload);
    return handleResponse(res);
  } catch (error) {
    console.error('[PublicEducation] registration error', error);
    const message =
      error?.response?.data?.resultMessage ||
      error?.message ||
      'Halk Eğitim başvurusu gönderilemedi.';
    return {
      isSuccess: false,
      resultMessage: message
    };
  }
}

export async function checkPublicEducationRegistrationDuplicate(payload) {
  try {
    const res = await axios.post(`${baseUrl}/public-education/registrations/duplicate-check`, payload);
    return handleResponse(res);
  } catch (error) {
    console.error('[PublicEducation] duplicate check error', error);
    return {
      isSuccess: false,
      resultMessage: error?.response?.data?.resultMessage || error?.message || 'KayÄ±t kontrolÃ¼ yapÄ±lamadÄ±.',
    };
  }
}

export async function getPublicEducationRegistrations(facilityId, sportTypeId) {
  try {
    const res = await axios.get(`${baseUrl}/public-education/registrations`, {
      params: {
        facilityId,
        sportTypeId
      }
    });
    return handleResponse(res);
  } catch (error) {
    console.error('[PublicEducation] get registrations error', error);
    return {
      isSuccess: false,
      resultMessage: error?.response?.data?.resultMessage || error?.message || 'Başvurular alınamadı.',
    };
  }
}



// CLUB APPLICATION
export async function createClubApplication(payload) {
  try {
    const res = await axios.post(`${baseUrl}/sports/club-applications`, payload);
    return handleResponse(res);
  } catch (error) {
    console.error('[SportsAppointment] club application error', error);
    const message =
      error?.response?.data?.resultMessage ||
      error?.message ||
      'Kulüp başvurusu gönderilemedi.';
    return {
      isSuccess: false,
      resultMessage: message,
    };
  }
}

export async function verifyClubRegistration(payload) {
  try {
    const res = await axios.post(`${baseUrl}/sports-management/verify-club`, payload);
    return handleResponse(res);
  } catch (error) {
    console.error('[SportsAppointment] verify club error', error);
    const message =
      error?.response?.data?.resultMessage ||
      error?.message ||
      'Kulüp doğrulanamadı.';
    return {
      isSuccess: false,
      resultMessage: message,
    };
  }
}

export async function getClubPaymentInfo(taxNumber, options = {}) {
  try {
    const params = {};
    if (options.clubApplicationId) params.clubApplicationId = options.clubApplicationId;
    if (options.facilityId) params.facilityId = options.facilityId;
    const res = await axios.get(`${baseUrl}/sports/club-applications/payment-info/${taxNumber}`, { params });
    return handleResponse(res);
  } catch (error) {
    console.error('[SportsAppointment] club payment info error', error);
    const message =
      error?.response?.data?.resultMessage ||
      error?.message ||
      'Kulüp ödeme bilgileri alınamadı.';
    return {
      isSuccess: false,
      resultMessage: message,
    };
  }
}
